import { isUnsafeInputRejection } from './unsafe-input-rejection';

/**
 * Turns an unsafe-input rejection into the caller's empty page, so a list screen shows "no results" for a term
 * the input-safety rule refuses, whether the client or Kt.Api rejected it.
 *
 * Only a collection endpoint's adapter may use it: an empty page is a true answer for a list, never for a
 * single-item or write call. The wrapper itself logs nothing; a rejection belongs in the log of whoever raises it,
 * so wrapping a call never adds a second entry for the same rejection.
 *
 * @param call Starts the request. It is a function so a synchronous throw is handled like a rejection.
 * @param emptyPage Builds the endpoint's empty response.
 * @returns The call's result, or `emptyPage()` for an unsafe-input rejection.
 * @throws {unknown} Every other failure, unchanged, including an abort.
 */
export async function emptyOnUnsafeInput<T>(call: () => Promise<T>, emptyPage: () => T): Promise<T> {
  try {
    return await call();
  } catch (error) {
    if (isUnsafeInputRejection(error)) {
      return emptyPage();
    }

    throw error;
  }
}
